import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Renderer_DataField_Base } from './Renderer_DataField_Base.js';
import { _className, GenericDropDownV3, stopPropagation, TS_Radio } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Advisor_Value } from '@app/advisor-frontend';
import { AdvisorDropDown_Values, props_advisorValueDropdown } from '../AdvisorUiComponents/AdvisorUiComponents.js';
import { resolveValueDisplay } from '@app/hcs-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { filterRelevantValues } from '@app/hcs-frontend';
export class Renderer_DataField_Value extends Renderer_DataField_Base {
    dropdownRef = React.createRef();
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.selectedValueId = nextProps.selectedValueId;
        state.allowUnknown = !!nextProps.allowUnknown;
        state.maxAllowedOptions = nextProps.maxAllowedOptions ?? 15;
        state.suggestedValue = nextProps.suggestedValue;
        //Collect allowed value ids
        const parentValue = ModuleFE_Advisor_Value.cache.unique(state.variable.valueId);
        if (!parentValue)
            throw new MUSTNeverHappenException(`Could not get parent value for id ${state.variable.valueId}`);
        state.allowedValueIds = filterRelevantValues(parentValue);
        return state;
    }
    //######################### Logic #########################
    getClassName = () => {
        return _className(super.getClassName(), 'value', (this.state.suggestedValue && !this.state.selectedValueId) && 'suggested');
    };
    onRadioSelect = (value) => {
        const id = typeof value === 'string' ? value : value?._id;
        //If we get undefined from radio we clicked a selected item.
        //If that selected item was the suggested value, we need to explicitly select it
        if (!id && this.state.suggestedValue)
            return this.props.onValueSelected(this.state.suggestedValue);
        this.props.onValueSelected(id);
    };
    onDropDownSelect = (value) => {
        const id = typeof value === 'string' ? value : value?._id;
        this.props.onValueSelected(id);
    };
    getValueLabel = (id) => {
        const value = ModuleFE_Advisor_Value.cache.unique(id);
        if (!value)
            throw new MUSTNeverHappenException(`Could not get parent value for id ${id}`);
        return resolveValueDisplay(value);
    };
    onVarNameClick = (e) => {
        if (!this.dropdownRef.current || this.state.disabled)
            return;
        stopPropagation(e);
        this.dropdownRef.current.setState({ open: !this.dropdownRef.current.state.open });
    };
    getSelectedValueId = () => {
        return this.state.selectedValueId ?? this.state.suggestedValue;
    };
    //######################### Render #########################
    render_DataIntake = () => {
        if (this.state.allowedValueIds.length > this.state.maxAllowedOptions)
            return this.render_DropDown();
        return this.render_Radio();
    };
    render_Radio = () => {
        const key = this.state.suggestedValue ? `s-${this.state.variable._id}` : this.state.variable._id;
        return _jsx(TS_Radio, { groupName: this.state.variable._id, onCheck: this.onRadioSelect, values: this.state.allowedValueIds, disabled: this.state.disabled, canUnselect: true, checked: this.getSelectedValueId(), labelRenderer: valueId => {
                const tooltipLogic = this.state.suggestedValue === valueId ? this.getSuggestedValueTooltipLogic() : {};
                return _jsx("div", { ...tooltipLogic, children: this.getValueLabel(valueId) });
            }, labelTooltipContainerSelector: '.ts-tree' }, key);
    };
    render_DropDown = () => {
        if (this.state.suggestedValue) {
            const props = {
                ...props_advisorValueDropdown,
                renderer: (value) => {
                    const tooltipLogic = this.state.suggestedValue === value._id ? this.getSuggestedValueTooltipLogic() : {};
                    return _jsx("div", { ...tooltipLogic, children: resolveValueDisplay(value) });
                }
            };
            const DropDown = GenericDropDownV3.prepare(props);
            return _jsx(DropDown.selectable, { dropdownRef: this.dropdownRef, onSelected: this.onDropDownSelect, selected: this.getSelectedValueId(), queryFilter: value => this.state.allowedValueIds.includes(value._id), canUnselect: this.state.allowUnknown, unselectLabel: 'Unknown', disabled: this.state.disabled, sortBy: [(item) => resolveValueDisplay(item).toLowerCase().trim()], placeholder: 'Unknown', caret: DropDown_DefaultCaret }, `s-${this.state.variable._id}`);
        }
        return _jsx(AdvisorDropDown_Values.selectable, { dropdownRef: this.dropdownRef, onSelected: this.onDropDownSelect, selected: this.getSelectedValueId(), queryFilter: value => this.state.allowedValueIds.includes(value._id), canUnselect: this.state.allowUnknown, unselectLabel: 'Unknown', disabled: this.state.disabled, sortBy: [(item) => resolveValueDisplay(item).toLowerCase().trim()], placeholder: 'Unknown', caret: DropDown_DefaultCaret }, this.state.variable._id);
    };
}
//# sourceMappingURL=Renderer_DataField_Value.js.map